import { Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { FormControl, FormGroup, Validators, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { HccModelCategory } from '../../../models/hcc-model-category';
import { Subscription } from 'rxjs';
import { FieldFilterService } from '../../../services/filters/field-filter.service';
import { MatSelect, MatSelectTrigger } from '@angular/material/select';
import { MatOption } from '@angular/material/core';
import { MatFormField, MatLabel } from '@angular/material/form-field';
import { MatTooltip } from '@angular/material/tooltip';

@Component({
    selector: 'app-hcc-model-category-select',
    templateUrl: './hcc-model-category-select.component.html',
    styleUrls: ['./hcc-model-category-select.component.scss'],
    imports: [MatFormField, MatLabel, MatSelect, FormsModule, ReactiveFormsModule, MatTooltip, MatSelectTrigger, MatOption]
})
export class HccModelCategorySelectComponent implements OnInit {
  @Input() form: FormGroup;
  @Input() color = 'primary';
  @Input() appearance = 'outline';
  @Input() label = 'Category';
  @Input() placeholder = '';
  @Input() floatLabel = 'always';
  @Input() multiple = true;
  @Input() controlName = 'model-category';
  @Input() toolTipPosition = 'above';
  @Input() required = false;
  @Input() queryOnInit = false;
  @Input() defaultValue = null;

  options: HccModelCategory[] = [];
  allOption = {ID: 0, Category: 'All', Selected: false};
  control: FormControl<HccModelCategory[] | HccModelCategory>;

  subs: Subscription[] = []

  @Output() ready = new EventEmitter();
  @Output() valueChanged = new EventEmitter();

  @ViewChild(MatSelect) select: MatSelect;

  constructor(private filterService: FieldFilterService) { }

  ngOnInit(): void {
    const validators = this.required ? [Validators.required] : [];
    this.control = this.multiple ? new FormControl<HccModelCategory[]>(this.defaultValue, validators) : new FormControl<HccModelCategory>(this.defaultValue, validators);
    this.form.addControl(this.controlName, this.control);

    if(this.queryOnInit) {
      this.getOptionData();
    }
  }

  getOptionData() {
    this.subs.push(this.filterService.getHccModelCategories().subscribe(result => {
      this.options = result;
      this.ready.emit(this.options);
    }));
  }

  setValues(values: HccModelCategory[]) {
    if(!values) {
      return;
    }

    if(values.length == 0) {
      this.control.setValue([this.allOption]);
      this.onToggleItem(this.select.options.get(0));
      return;
    }

    this.control.setValue(values);
  }

  setValuesByIDs(ids: number[]) {
    if(ids.length == 0) {
      this.control.setValue([this.allOption]);
      this.onToggleItem(this.select.options.get(0));
      return;
    }

    this.control.setValue(this.options.filter(i => ids.includes(i.ID)));
  }

  setSingleModeValue(value: HccModelCategory) {
    this.control.setValue(value);
  }

  setSingleModeValueByID(id: number) {
    this.control.setValue(this.options.find(i => i.ID == id));
  }

  getValues() {
    if(this.allOption.Selected) {
      return [this.allOption];
    }

    return this.control?.value;
  }

  onToggleItem(item: MatOption) {
    if(item.value == this.allOption) {
      if(item.selected) {
        this.allOption.Selected = true;
        this.select.options.forEach(o => o.select());
        return;
      }

      this.allOption.Selected = false;
      this.select.options.forEach(o => o.deselect());

    } else {
      
      const allItem = this.select.options.get(0);

      if(!item.selected && allItem.selected) {
        this.allOption.Selected = false;
        allItem.deselect();
        return;
      }

      if(item.selected && !allItem.selected) {
        const check = this.checkOptionAllStatus();
        if(check) {
          this.allOption.Selected = true;
          allItem.select();
        }
      }
    }
  }

  onSelectionChange() {
    const values = this.control?.value as HccModelCategory[];
    const options = this.allOption.Selected ? values.slice(1) : values;
    this.valueChanged.emit(options);
  }

  checkOptionAllStatus() {
    let result = true;
    this.select.options.forEach(o => {
      if(o.value != this.allOption && !o.selected) {
        result = false;
      }
    });

    return result;
  }

  getTooltipString() {
    if(!this.multiple) {
      return '';
    }

    let result = '';

    const values = this.control?.value as HccModelCategory[];
    const options = this.allOption.Selected ? values.slice(1) : values;

    options.forEach((o, index) => {
      result += o.Category;

      if(index < options.length - 1) {
        result += ', ';
      }
    })
    return result;
  }

  getSelectCount() {
    const values = this.control.value as HccModelCategory[];

    return (values?.length <= this.options.length) 
      ? values?.length 
      : values?.length - 1;
  }

}
